import { useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/login", { replace: true }); return; }

    (async () => {
      try {
        // Backend cria o httpOnly cookie 'session_token' na resposta.
        // Não guardamos o token no cliente para eliminar risco de XSS.
        const { data } = await api.post("/auth/session", { session_id });
        window.history.replaceState(null, "", window.location.pathname);
        const u = data?.user;
        if (u?.is_admin || u?.is_finance || u?.is_accountant || u?.perfil_unidade) {
          navigate("/admin", { replace: true, state: { user: u } });
        } else if (u?.is_cleaning) {
          navigate("/limpeza", { replace: true, state: { user: u } });
        } else {
          navigate("/login", { replace: true, state: { error: "forbidden" } });
        }
      } catch (err) {
        const forbidden = err?.response?.status === 403;
        navigate("/login", { replace: true, state: { error: forbidden ? "forbidden" : "auth_failed" } });
      }
    })();
    // location/navigate são estáveis do React Router; deps aqui só precisam disparar quando o hash muda.
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#F5F1E8] flex items-center justify-center">
      <div className="text-stone-500 text-sm">Autenticando…</div>
    </div>
  );
}
